import { isEmptyString } from "./Validators";

export const phoneFormat = (input: string) => {
  // Strip all characters from the input except digits
 
  let updatedInput = input.replace(/\D/g, "");
 

  // Trim the remaining input to ten characters, to preserve phone number format
  updatedInput = updatedInput.substring(0, 10);

  // Based upon the length of the string, we add formatting as necessary
  var size = updatedInput.length;
  if (size == 0) {
    updatedInput = updatedInput;
  } else if (size < 4) {
    updatedInput = "(" + updatedInput;
  } else if (size < 7) {
    updatedInput =
      "(" + updatedInput.substring(0, 3) + ") " + updatedInput.substring(3, 6);
  } else {
    updatedInput =
      "(" +
      updatedInput.substring(0, 3) +
      ") " +
      updatedInput.substring(3, 6) +
      " - " +
      updatedInput.substring(6, 10);
  }
  return updatedInput;
};

export const parseRealMobileVal = (value: any) => {
  let a =value;
  a = a.split(" ").join("");
  return a.match(/([\d]+)/g).join("");
};

export const isInValidMobileNumber = (value: string) =>
  value.length < 16 || isEmptyString(value);
